// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mt-1";
export var messageSideRight = "_mt-2";
export var subscribeToBackInStockBubbleContainer = "_mt-0";